<template>
  <div class="main">
    <a-form :form="form" @submit="handleSubmit" class="form">
      <p class="title">欢迎注册{{ projectName }}</p>
      <a-form-item>
        <a-input
          size="large"
          v-decorator="['email', { rules: [{ required: true, message: '请输入邮箱!', type:'email' }] }]"
          placeholder="请输入邮箱，作为登录账号"
        />
      </a-form-item>
      <a-form-item>
        <a-input
          size="large"
          v-decorator="['password', { rules: [{ required: true, message: '请输入密码!' }] }]"
          placeholder="请输入账号密码"
        />
      </a-form-item>
      <a-form-item>
        <a-input
          size="large"
          v-decorator="['mobile', { rules: [{ required: true, message: '请输入手机号!' }] }]"
          placeholder="请输入手机号"
        />
      </a-form-item>
      <a-form-item>
        <a-input
          size="large"
          v-decorator="[ 'captcha',  { rules: [{ required: true, message: '请输入手机验证码!' }] }]"
          placeholder="请输入手机验证码"
        >
          <a slot="addonAfter">获取验证码</a>
        </a-input>
      </a-form-item>

      <a-form-item>
        <a-button size="large" type="primary" html-type="submit" class="login-form-button">注册</a-button>
      </a-form-item>
      <a-form-item>
        <p class="license">点击注册，表示您已阅读并同意</p>
        <p class="license">
          <a>{{ projectName }}服务用户协议</a> 和
          <a>隐私权政策</a>
        </p>
        <a @click="onBack">已有账号，返回登录</a>
      </a-form-item>
    </a-form>
    <a-divider />
    <p>Copyright © 2019 {{ projectName }}. All rights reserved.上海阿尔卡特网络支援系统有限公司版权所有</p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: this.$form.createForm(this)
    };
  },
  computed: {
    projectName() {
      return this.$store.state.projectName;
    }
  },
  methods: {
    handleSubmit() {},
    onBack() {
      this.$router.back();
    }
  }
};
</script>

<style scoped>
.main {
  text-align: center;
  width: 100%;
  overflow: hidden;
}

.main .form {
  margin: 10% auto;
  width: 360px;
}

.main .form .title {
  float: left;
  font-size: 24px;
}

.login-form-button {
  width: 100%;
}

.license {
  font-size: 10px;
  color: #a1a1a1;
  line-height: 20px;
}

.item {
  height: 45px;
}
</style>